<template>
  <div class="local-targets">
    <div class="app-step-two-tabs-targeting-tabs__descr">
      <p class="industry-targets__title">
        Select One Local Area for Targeting & Saturation
      </p>
      <p class="industry-targets__su1btitle">
        All of our press releases are distributed nationally, but you may select
        a
        <b>single</b> US locality for saturated coverage for
        <b>{{ localAreaPrice }}</b
        >. The locality can be either a city / metropolitan area or a state.
        Simply enter the locality for the saturation order below. We are able to
        target only a single locality in addition to our national distribution
      </p>
    </div>

    <targeting-list
      :selected-items="selectedItems"
      :resource-url="API.getLocalAreasResource"
      :single-item="true"
      payload-key-name="localAreaSaturation"
    ></targeting-list>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatPrice } from '@core/utils/price'
import { useOrder } from '@core/composables/order/useOrder'

import API from '@core/api'
import TargetingList from '@modules/app-steps/step-two/tabs/targeting/targeting-list/index.vue'
import 'vue-select/dist/vue-select.css'

const { order } = useOrder()
const selectedItems = computed(() =>
  order?.value?.localArea ? [order.value.localArea] : []
)

const localAreaPrice = computed(() =>
  formatPrice(order.value?.packagePrice?.package?.localAreasPrice)
)
</script>
